import classNames from 'classnames/bind';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import styles from './LoadForm.module.scss';

import { PrimaryButton } from '@/components/ui/kit/Button';
import MissionPreview from '@/components/ui/MissionPreview';
import MissionTable from '@/components/ui/MissionTable';
import { getCommandForSurveySegment } from '@/helpers/CommandConverter';
import { getMission } from '@/helpers/Requester';
import { modalManager } from '@/libs/ModalContainer';
import { NotifierService as notifier } from '@/libs/Notifier';

const cx = classNames.bind(styles);

const LoadForm = () => {
  const navigate = useNavigate();
  const [selectedMission, setSelectedMission] = useState();

  const handleSelect = (mission) => {
    // 미션 선택 해제된 경우 (예: 미션 삭제)
    if (!mission) {
      setSelectedMission(null);
      return;
    }

    getMission(mission.id).then(({ success, data }) => {
      if (success) {
        const mission = structuredClone(data);
        mission.json.commands = mission.json.commands.map((command) => getCommandForSurveySegment(command));
        setSelectedMission(mission);
      }
    });
  };

  const doOK = () => {
    if (!selectedMission) {
      notifier.error('Please select a mission.');
      return;
    }

    navigate(`/mission-hub/${selectedMission.id}`, { replace: true });
    modalManager.hide();
  };

  return (
    <div className={cx('container')}>
      <div className={cx('wrapper')}>
        <MissionTable onSelectMission={handleSelect} />
        <MissionPreview mission={selectedMission} />
      </div>
      <PrimaryButton text="OK" accent center onClick={doOK} />
    </div>
  );
};

export default LoadForm;
